import React, { Component } from 'react'

import FrameComponent from '../../DashboardContainer/Component/FrameComponent'
import Phi from '../../../Phi/Phi'

import HSGCard from '../../../Components/HSGCard/HSGCard'
import './Report.css'

const goBackImage = '/9j/4QAYRXhpZgAASUkqAAgAAAAAAAAAAAAAAP/sABFEdWNreQABAAQAAABkAAD/4QMraHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLwA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/PiA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA1LjMtYzAxMSA2Ni4xNDU2NjEsIDIwMTIvMDIvMDYtMTQ6NTY6MjcgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCBDUzYgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjM3MzBFMzMxRkU2NTExRTZCQjkzRkM3QTUyRDcxRjZEIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjM3MzBFMzMyRkU2NTExRTZCQjkzRkM3QTUyRDcxRjZEIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MzczMEUzMkZGRTY1MTFFNkJCOTNGQzdBNTJENzFGNkQiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MzczMEUzMzBGRTY1MTFFNkJCOTNGQzdBNTJENzFGNkQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7/7gAOQWRvYmUAZMAAAAAB/9sAhAABAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAgICAgICAgICAgIDAwMDAwMDAwMDAQEBAQEBAQIBAQICAgECAgMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwP/wAARCAALAAcDAREAAhEBAxEB/8QAXQABAQAAAAAAAAAAAAAAAAAABgoBAQAAAAAAAAAAAAAAAAAAAAAQAAAFAwMDBQAAAAAAAAAAAAMEBQYHFBYIEhUXASITAAImGBkRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AKp4lkV+ZHZkywO/XS5YwJYjqiymx3iUjqw7feEh9FJLFTg5wkY2MZSkJ5NpwElP2BoZUqcMJZOrA6jjBgjVC0DWb7b/AEIxH3bh3eLTfewUPK32S1W8+q3z2T8F4U1+DTc3ZW7jS9lZ6D//2Q=='
const downloadImage = '/9j/4QAYRXhpZgAASUkqAAgAAAAAAAAAAAAAAP/sABFEdWNreQABAAQAAABkAAD/4QMraHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLwA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/PiA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA1LjMtYzAxMSA2Ni4xNDU2NjEsIDIwMTIvMDIvMDYtMTQ6NTY6MjcgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCBDUzYgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjI2OUI2N0Q2RkU2NTExRTY5OTlDOTdBQkY1NzREMzEyIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjI2OUI2N0Q3RkU2NTExRTY5OTlDOTdBQkY1NzREMzEyIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MjY5QjY3RDRGRTY1MTFFNjk5OUM5N0FCRjU3NEQzMTIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MjY5QjY3RDVGRTY1MTFFNjk5OUM5N0FCRjU3NEQzMTIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7/7gAOQWRvYmUAZMAAAAAB/9sAhAABAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAgICAgICAgICAgIDAwMDAwMDAwMDAQEBAQEBAQIBAQICAgECAgMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwP/wAARCAALAAsDAREAAhEBAxEB/8QAZwABAQEAAAAAAAAAAAAAAAAACQMKAQEAAAAAAAAAAAAAAAAAAAAAEAAAAgcGAwkBAAAAAAAAAAASBhEDEwQUBQcAAQIVFhchIggjgzVllSZHZxgJEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwB2v6PVaqkbuqPpHMFFixTqrxIoxURSdC4ZyVUmXTeXXmRfdJJtOi7V9+cMSyWUvlrg5EZ7fFcxe10GslOB5X3rbr3R6wKQW39LF1At2ulUO2EcLfOWI3eGyyZMKjbdpy5n4iLhBpsGFYjCyyosProWnHNjpBlpIWqZIz3NzLsdEJQCI5Y+HHwTYJ+4Yv41ig/V8I2yT0cWT9xHeZ2D/9k='

class Report extends Component {

    constructor(props) {
        super(props)
        this.state = {
            cardHeight: '400px',
            reportType: null
        }
    }

    getReport = (reportType, config, studentId) => {
        if(studentId){
            let newConfig = {...config, startNodeId: Number(config.eventNodeId), studentId: String(studentId)}
            delete newConfig.eventNodeId
            this.props.getStudentReport(reportType, newConfig)
            if(reportType === "dental" || reportType === "eye"){
                this.props.getDMFTIndex(studentId, parseInt(config.eventNodeId))
            } 
        } else {
            let newConfig = {...config, eventNodeId: Number(config.eventNodeId)}
            this.props.getReport(reportType, newConfig)
        }
    } 

    componentWillMount() {       
         
            if (this.props.startNodeId) {
                let startNode = this.props.startNodeId
                if (startNode) {
                    this.getReport(this.props.match.params.type, { eventNodeId: startNode, studentId: this.props.studentId, type: 'html' }, this.props.studentId)
                    
                    this.setState ({ reportType: this.props.match.params.type })
                }            
            } 
    }

    componentWillReceiveProps(newProps) {
        if (JSON.stringify(newProps.currentProgram) !== JSON.stringify(this.props.currentProgram)) {
            let startNode = newProps.startNodeId
            this.getReport(this.props.match.params.type, { eventNodeId: startNode, studentId: this.props.studentId, type: 'html' }, this.props.studentId)
                
            this.setState ({ reportType: this.props.match.params.type })
        }
    }

    changeHeight = (height) => {
        this.setState({
            cardHeight: height
        })
    }

    _downloadPdf = () => {
        this.props.setLoader()
        let startNode = this.props.startNodeId
        this.getReport(this.props.match.params.type, { eventNodeId: startNode, studentId: this.props.studentId, type: 'pdf' }, this.props.studentId)   
    }

    // _renderDownloadPdf = () => {
    //     return (
    //         <button onClick={() => this._downloadPdf()} className="btn hsg-btn-consltNow hsg-btn-primary">
    //             Download Report
    //         </button>
    //     )
    // }

    _renderDownloadPdf = () => {

        const reportDownloadBtn = <button onClick={() => this._downloadPdf()}
                                        style={{marginBottom: 10}}
                                        // className="btn hsg-btn-consltNow hsg-btn-primary">
                                        className="btn hsg-report-download-btn">
                                        <img src={`data:image/jpeg;base64,${downloadImage}`} style={{ position: 'relative', right: '4px', bottom: '1px' }} />
                                        Download
                                    </button>;

        if (this.props.htmlContent) {

            return <div className="hsg-report-download">
                    <div onClick={() => window.close()} className="hsg-report-back-btn">
                        <span aria-hidden="true" data-icon="&#e906;" className="icon-previous previous-btn"></span>
                        <img src={`data:image/jpeg;base64,${goBackImage}`} style={{ position: 'relative', right: '4px', bottom: '0px' }} />
                        BACK
                    </div>
                    {
                       reportDownloadBtn
                    }
                    </div>
        } else
            return null 
                
    }

    _renderCMSImage = () => {

        return <div className="hsg-parent-cms" style = {{margin: 10}}>
                    <p>powered by</p>
                    {/* <img src={CMSImage} height={28} weight={28}/> */}
                </div>

    }

    render() {
        let organization = JSON.parse(Phi.Storage.getItem('organization'))

        return (
            <HSGCard headingLeft={`${organization && organization[0] ? organization[0].organization_name : ''}`} headingRight={this._renderDownloadPdf()} style={{ height: this.state.cardHeight, padding: 0}} hideHeader>                                                                        
                <div id="hsg-frameDiv">
                    <FrameComponent 
                        student={Boolean(this.props.studentId)}
                        changeHeight={(height) => this.changeHeight(height)} 
                        htmlContent={this.props.htmlContent} 
                        reportType={this.props.match.params.type}    
                        downloadBtn={this._renderDownloadPdf()}
                        dmftIndex={this.props.dmftIndex}
                        CMSImage={this._renderCMSImage()}
                    />                                    
                </div>    
            </HSGCard>
        )
    }

}


export default Report


// WEBPACK FOOTER //
// ./src/Containers/ReportContainer/Component/Report.js